<mat-nav-list>
  <!-- Categorías -->
  <a
    *ngFor="let categoria of categorias$ | async"
    mat-list-item
    (click)="seleccionarCategoria(categoria)"
    [class.active]="categoria.ruta === categoriaActivaRuta"
  >
    <mat-icon matListItemIcon>{{ categoria.icono }}</mat-icon>
    <span matListItemTitle>{{ categoria.nombre }}</span>
  </a>
</mat-nav-list>
